import useQueryContext from '@hooks/useQueryContext'
import Link from 'next/link'
import dynamic from 'next/dynamic'
import { MenuIcon } from '@heroicons/react/solid'

const ConnectWalletButtonDynamic = dynamic(
  async () => await import('./ConnectWalletButton'),
  { ssr: false },
)

interface Props {
  onBurgerClick: () => void
}

const NavBar = ({ onBurgerClick }: Props) => {
  const { fmtUrlWithCluster } = useQueryContext()

  return (
    <div className="flex items-center justify-between w-full relative z-20 bg-bkg-2">
      <div className="flex items-center justify-between h-20 col-span-12 px-4 xl:col-start-2 xl:col-span-10 md:px-8 xl:px-4 w-full">
        <div className="flex gap-2 items-center relative">
          <button className="xl:hidden p-1" onClick={onBurgerClick}>
            <MenuIcon className="h-5 w-5" />
          </button>
          <Link href={fmtUrlWithCluster('/')}>
            <div className="flex cursor-pointer items-center gap-1 min-w-[36px]">
              <picture>
                <img src="/img/logo.png" className="w-5 h-5 sm:w-9 sm:h-9" />
              </picture>
              <span className="sm:text-[28px]">DAO</span>
            </div>
          </Link>
        </div>

        <div className="flex items-center justify-end space-x-2 md:space-x-4">
          <ConnectWalletButtonDynamic />
        </div>
      </div>
    </div>
  )
}

export default NavBar
